import { Trans, useTranslation } from 'react-i18next';
import { config } from '@/config';
import { Divider, Link, Text } from '@/ui';

// The footer for a manually granted (offline/check) subscription, personal or
// workspace: there's no Stripe customer behind it, so the billing portal would
// fail and support is the only way to change it.
export const ManualPlanSupportNotice = () => {
  const { t } = useTranslation('settingsModal', { keyPrefix: 'subscription' });

  return (
    <>
      <Divider />
      <Text color="customgray.mid">
        <Trans i18nKey="plan.contact_support" t={t}>
          <Link
            colorScheme="dark"
            href={config.supportHref}
            rel="noopener noreferrer"
            target="_blank"
            textDecoration="underline"
          >
            Contact support
          </Link>
          to manage this subscription.
        </Trans>
      </Text>
    </>
  );
};
